<template>
  <span class="lightIntensityWidget">
    <span
      v-if="lightState"
      :title="'Lights ' + lightState + ' at ' + lightIntensityAverage + '%'"
    >
      <span v-if="(lightState.toLowerCase() === 'on' || lightIntensityAverage > 0) && lightState.toLowerCase() !== 'updating'">
        <template v-if="lightIntensityAverage > 0">
          <v-badge left overlap :color="color" class="lightIntensity">
            <template v-slot:badge>
              <span style="font-weight: bold">{{ lightIntensityAverage }}</span>
            </template>
            <v-icon :size="iconSize" :color="color">wb_incandescent</v-icon>
          </v-badge>
        </template>
        <v-icon :size="iconSize" :color="disabledColor" v-else>wb_incandescent</v-icon>
      </span>
      <span v-else-if="lightState.toLowerCase() === 'off'">
        <v-icon :size="iconSize" :color="disabledColor">wb_incandescent</v-icon>
      </span>
      <span v-else-if="lightState.toLowerCase() === 'updating'">
        <img src="/img/Spinner-1s-30px.gif" />
      </span>
    </span>
  </span>
</template>

<script>
export default {
  name: "",
  props: ["lightState", "lightIntensityAverage", "iconSize", "disabled"],
  components: {},
  beforeMount() {},
  mounted() {},
  data() {
    return {};
  },

  computed: {
    color() {
      return this.disabled ? 'rgb(192, 192, 192)': '#FF00FF'
    },
    disabledColor() {
      return this.disabled ? 'rgb(192, 192, 192)': null
    }
  },
  watch: {},
  methods: {}
};
</script>
<style lang="scss">
.lightIntensityWidget .v-badge__badge {
  height: 15px;
  width: 15px;
  border-radius: 50%;
  padding: 0px 0px;
  min-width: 15px;
  right: calc(100% - 3px) !important;
  span {
    font-size: 8px;
  }
}
</style>
